import { render, staticRenderFns } from "./HasGiftAlert.vue?vue&type=template&id=e384ca4e"
import script from "./HasGiftAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./HasGiftAlert.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports